<template>
  <div class="_mb-md-50 _mb-sm-30">
    <p class="-spnone">
      アップロード時のご確認事項をお読みいただき、「ファイルを選択する」を押してアップロードしてください。
    </p>
    <p class="-pcnone">
      アップロード時のご確認事項をお読みいただき、「アップロードする」を押してアップロードしてください。
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TxtTop",
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
